export default class Focus {
  constructor(node) {
    this.element = node;

    this.initialize();
  }

  initialize() {
    this.element.focus();
    this.element.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
